import Icon from "@ant-design/icons";

import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;
const GoodsSearchSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
  >
    <path
      fill="none"
      stroke="currentColor"
      d="M13.5 5v8.5h-11V5m11 0L11 2.5H5L2.5 5m11 0h-11M9 10l1.5 1.5M9.5 9a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0Z"
      strokeWidth={1}
    ></path>
  </svg>
);
const GoodsSearchIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={GoodsSearchSvg} {...props} />
);
export default GoodsSearchIcon;
